/*
 * 从 ua-parser-js 中提取的部分代码 https://github.com/faisalman/ua-parser-js
 * 用于解析 UA
 * 增强了UA识别的能力，可以识别更多的设备
 */

const NAVIGATOR = window.navigator;
const USER_AGENT = NAVIGATOR?.userAgent;
const UA_MAX_LENGTH = 350;

const MODEL = 'model',
	NAME = 'name',
	TYPE = 'type',
	VENDOR = 'vendor',
	VERSION = 'version';
const EMPTY = '',
	CONSOLE = 'console',
	MOBILE = 'mobile',
	TABLET = 'tablet',
	SMARTTV = 'smarttv',
	WEARABLE = 'wearable',
	EMBEDDED = 'embedded';
const AMAZON = 'Amazon',
	APPLE = 'Apple',
	ASUS = 'ASUS',
	BLACKBERRY = 'BlackBerry',
	GOOGLE = 'Google',
	HUAWEI = 'Huawei',
	LG = 'LG',
	MICROSOFT = 'Microsoft',
	MOTOROLA = 'Motorola',
	SAMSUNG = 'Samsung',
	SHARP = 'Sharp',
	SONY = 'Sony',
	XIAOMI = 'Xiaomi',
	ZEBRA = 'Zebra',
	PREFIX_MOBILE = 'Mobile ',
	SUFFIX_BROWSER = ' Browser',
	CHROME = 'Chrome',
	EDGE = 'Edge',
	FIREFOX = 'Firefox',
	OPERA = 'Opera',
	FACEBOOK = 'Facebook',
	WINDOWS = 'Windows';

const WINDOWS_VER_MAP = {
	ME: '4.90',
	'NT 3.11': 'NT3.51',
	'NT 4.0': 'NT4.0',
	2000: 'NT 5.0',
	XP: ['NT 5.1', 'NT 5.2'],
	Vista: 'NT 6.0',
	7: 'NT 6.1',
	8: 'NT 6.2',
	8.1: 'NT 6.3',
	10: ['NT 6.4', 'NT 10.0'],
	RT: 'ARM',
};

const has = (str1, str2) => {
	return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
};

const strMapper = (str, map) => {
	for (const key in map) {
		if (key != null) {
			const val = map[key];
			if (typeof val === 'object' && val.length > 0) {
				for (let j = 0; j < val.length; j++) {
					if (has(val[j], str)) {
						return key;
					}
				}
			} else if (has(val, str)) {
				return key;
			}
		}
	}
	return str;
};

const trim = (str, len) => {
	if (typeof str === 'string') {
		str = str.replace(/^\s\s*/, EMPTY);
		return typeof len === 'undefined' ? str : str.substring(0, UA_MAX_LENGTH);
	}
};

// 一个 REGEX 数组， 一个 PROPS 顺序数组
const REGEX_OS = [
	// Windows
	[
		/microsoft (windows) (vista|xp)/i, // Windows (iTunes)
	],
	[NAME, VERSION],
	[
		/(windows) nt 6\.2; (arm)/i, // Windows RT
		/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i, // Windows Phone
		/(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
	],
	[NAME, [VERSION, strMapper, WINDOWS_VER_MAP]],
	[/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i],
	[
		[NAME, WINDOWS],
		[VERSION, strMapper, WINDOWS_VER_MAP],
	],
	// iOS/macOS
	[
		/ip[honead]{2,4}\b(?:.*os ([\w\(\)]+) like mac|; opera)/i, // iOS
		/ios;fbsv\/([\d\.]+)/i,
		/cfnetwork\/.+darwin/i,
	],
	[
		[VERSION, /_/g, '.'],
		[NAME, 'iOS'],
	],
	[
		/(mac os x) ?([\w\. ]*)/i,
		/(macintosh|mac_powerpc\b)(?!.+haiku)/i, // Mac OS
	],
	[
		[NAME, 'macOS'],
		[VERSION, /_/g, '.'],
	],
	// Mobile OSes
	[
		/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i, // Android-x86/HarmonyOS
	],
	[VERSION, NAME],
	[
		// Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
		/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
		/(blackberry)\w*\/([\w\.]*)/i, // Blackberry
		/(tizen|kaios)[\/ ]([\w\.]+)/i, // Tizen/KaiOS
		/\((series40);/i, // Series 40
	],
	[NAME, VERSION],
	[
		/\(bb(10);/i, // BlackBerry 10
	],
	[VERSION, [NAME, BLACKBERRY]],
	[
		/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i, // Symbian
	],
	[VERSION, [NAME, 'Symbian']],
	[
		/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i, // Firefox OS
	],
	[VERSION, [NAME, FIREFOX + ' OS']],
	[
		/web0s;.+rt(tv)/i,
		/\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i, // WebOS
	],
	[VERSION, [NAME, 'webOS']],
	[
		/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i, // watchOS
	],
	[VERSION, [NAME, 'watchOS']],
	// Google Chromecast
	[
		/crkey\/([\d\.]+)/i, // Google Chromecast
	],
	[VERSION, [NAME, CHROME + 'cast']],
	[
		/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i, // Chromium OS
	],
	[[NAME, 'Chrome OS'], VERSION],
	// Smart TVs
	[
		/panasonic;(viera)/i, // Panasonic Viera
		/(netrange)mmh/i, // Netrange
		/(nettv)\/(\d+\.[\w\.]+)/i, // NetTV

		// Console
		/(nintendo|playstation) (\w+)/i, // Nintendo/Playstation
		/(xbox); +xbox ([^\);]+)/i, // Microsoft Xbox (360, One, X, S, Series X, Series S)

		// Other
		/\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, // Joli/Palm
		/(mint)[\/\(\) ]?(\w*)/i, // Mint
		/(mageia|vectorlinux)[; ]/i, // Mageia/VectorLinux
		/([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
		// Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
		/(hurd|linux) ?([\w\.]*)/i, // Hurd/Linux
		/(gnu) ?([\w\.]*)/i, // GNU
		/\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
		/(haiku) (\w+)/i, // Haiku
	],
	[NAME, VERSION],
	[
		/(sunos) ?([\w\.\d]*)/i, // Solaris
	],
	[[NAME, 'Solaris'], VERSION],
	[
		/((?:open)?solaris)[-\/ ]?([\w\.]*)/i, // Solaris
		/(aix) ((\d)(?=\.|\)| )[\w\.])*/i, // AIX
		/\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
		/(unix) ?([\w\.]*)/i, // UNIX
	],
	[NAME, VERSION],
];

const REGEX_BROWSER = [
	// Most common regardless engine
	[
		/\b(?:crmo|crios)\/([\w\.]+)/i, // Chrome for Android/iOS
	],
	[VERSION, [NAME, PREFIX_MOBILE + 'Chrome']],
	[
		/edg(?:e|ios|a)?\/([\w\.]+)/i, // Microsoft Edge
	],
	[VERSION, [NAME, EDGE]],
	// Presto based
	[
		/(opera mini)\/([-\w\.]+)/i, // Opera Mini
		/(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, // Opera Mobi/Tablet
		/(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i, // Opera
	],
	[NAME, VERSION],
	[
		/opios[\/ ]+([\w\.]+)/i, // Opera mini on iphone >= 8.0
	],
	[VERSION, [NAME, OPERA + ' Mini']],
	[
		/\bopr\/([\w\.]+)/i, // Opera Webkit
	],
	[VERSION, [NAME, OPERA]],
	// Mixed
	[
		/(kindle)\/([\w\.]+)/i, // Kindle
		/(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i, // Lunascape/Maxthon/Netfront/Jasmine/Blazer
		// Trident based
		/(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i, // Avant/IEMobile/SlimBrowser
		/(ba?idubrowser)[\/ ]?([\w\.]+)/i, // Baidu Browser
		/(?:ms|\()(ie) ([\w\.]+)/i, // Internet Explorer

		// Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
		/(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
		// Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo
		/(heytap|ovi)browser\/([\d\.]+)/i, // HeyTap/Ovi
		/(weibo)__([\d\.]+)/i, // Weibo
	],
	[NAME, VERSION],
	[
		/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i, // UCBrowser
	],
	[VERSION, [NAME, 'UCBrowser']],
	[
		/microm.+\bqbcore\/([\w\.]+)/i, // WeChat Desktop for Windows Built-in Browser
		/\bqbcore\/([\w\.]+).+microm/i,
	],
	[VERSION, [NAME, 'WeChat(Win) Desktop']],
	[
		/micromessenger\/([\w\.]+)/i, // WeChat
	],
	[VERSION, [NAME, 'WeChat']],
	[
		/konqueror\/([\w\.]+)/i, // Konqueror
	],
	[VERSION, [NAME, 'Konqueror']],
	[
		/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i, // IE11
	],
	[VERSION, [NAME, 'IE']],
	[
		/ya(?:search)?browser\/([\w\.]+)/i, // Yandex
	],
	[VERSION, [NAME, 'Yandex']],
	[
		/(avast|avg)\/([\w\.]+)/i, // Avast/AVG Secure Browser
	],
	[[NAME, /(.+)/, '$1 Secure' + SUFFIX_BROWSER], VERSION],
	[
		/\bfocus\/([\w\.]+)/i, // Firefox Focus
	],
	[VERSION, [NAME, FIREFOX + ' Focus']],
	[
		/\bopt\/([\w\.]+)/i, // Opera Touch
	],
	[VERSION, [NAME, OPERA + ' Touch']],
	[
		/coc_coc\w+\/([\w\.]+)/i, // Coc_Coc Browser
	],
	[VERSION, [NAME, 'Coc Coc']],
	[
		/dolfin\/([\w\.]+)/i, // Dolphin
	],
	[VERSION, [NAME, 'Dolphin']],
	[
		/coast\/([\w\.]+)/i, // Opera Coast
	],
	[VERSION, [NAME, OPERA + ' Coast']],
	[
		/miuibrowser\/([\w\.]+)/i, // MIUI Browser
	],
	[VERSION, [NAME, 'MIUI' + SUFFIX_BROWSER]],
	[
		/fxios\/([\w\.-]+)/i, // Firefox for iOS
	],
	[VERSION, [NAME, PREFIX_MOBILE + FIREFOX]],
	[
		/\bqihu|(qi?ho?o?|360)browser/i, // 360
	],
	[[NAME, '360' + SUFFIX_BROWSER]],
	[/(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i],
	[[NAME, /(.+)/, '$1' + SUFFIX_BROWSER], VERSION],
	// Oculus/Samsung/Sailfish/Huawei Browser
	[
		/(comodo_dragon)\/([\w\.]+)/i, // Comodo Dragon
	],
	[[NAME, /_/g, ' '], VERSION],
	[
		/(electron)\/([\w\.]+) safari/i, // Electron-based App
		/(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, // Tesla
		/m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i, // QQBrowser/Baidu App/2345 Browser
	],
	[NAME, VERSION],
	[
		/(metasr)[\/ ]?([\w\.]+)/i, // SouGouBrowser
		/(lbbrowser)/i, // LieBao Browser
		/\[(linkedin)app\]/i, // LinkedIn App for iOS & Android
	],
	[NAME],
	// WebView
	[
		/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i, // Facebook App for iOS & Android
	],
	[[NAME, FACEBOOK], VERSION],
	[
		/(kakao(?:talk|story))[\/ ]([\w\.]+)/i, // Kakao App
		/(naver)\(.*?(\d+\.[\w\.]+).*\)/i, // Naver InApp
		/safari (line)\/([\w\.]+)/i, // Line App for iOS
		/\b(line)\/([\w\.]+)\/iab/i, // Line App for Android
		/(chromium|instagram)[\/ ]([-\w\.]+)/i, // Chromium/Instagram
	],
	[NAME, VERSION],
	[
		/\bgsa\/([\w\.]+) .*safari\//i, // Google Search Appliance on iOS
	],
	[VERSION, [NAME, 'GSA']],
	[
		/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i, // TikTok
	],
	[VERSION, [NAME, 'TikTok']],
	[
		/headlesschrome(?:\/([\w\.]+)| )/i, // Chrome Headless
	],
	[VERSION, [NAME, CHROME + ' Headless']],
	[
		/ wv\).+(chrome)\/([\w\.]+)/i, // Chrome WebView
	],
	[[NAME, CHROME + ' WebView'], VERSION],
	[
		/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i, // Android Browser
	],
	[VERSION, [NAME, 'Android' + SUFFIX_BROWSER]],
	[
		/chrome\/([\w\.]+) mobile/i, // Chrome Mobile
	],
	[VERSION, [NAME, PREFIX_MOBILE + 'Chrome']],
	[
		/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i, // Chrome/OmniWeb/Arora/Tizen/Nokia
	],
	[NAME, VERSION],
	[
		/version\/([\w\.\,]+) .*mobile(?:\/\w+ | ?)safari/i, // Safari Mobile
	],
	[VERSION, [NAME, PREFIX_MOBILE + 'Safari']],
	[/iphone .*mobile(?:\/\w+ | ?)safari/i],
	[[NAME, PREFIX_MOBILE + 'Safari']],
	[
		/version\/([\w\.\,]+) .*(safari)/i, // Safari
	],
	[VERSION, NAME],
	[
		/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i, // Safari < 3.0
	],
	[NAME, [VERSION, '1']],
	[/(webkit|khtml)\/([\w\.]+)/i],
	[NAME, VERSION],
	// Gecko based
	[
		/(?:mobile|tablet);.*(firefox)\/([\w\.-]+)/i, // Firefox Mobile
	],
	[[NAME, PREFIX_MOBILE + FIREFOX], VERSION],
	[
		/(navigator|netscape\d?)\/([-\w\.]+)/i, // Netscape
	],
	[[NAME, 'Netscape'], VERSION],
	[
		/mobile vr; rv:([\w\.]+)\).+firefox/i, // Firefox Reality
	],
	[VERSION, [NAME, FIREFOX + ' Reality']],
	[
		/ekiohf.+(flow)\/([\w\.]+)/i, // Flow
		/(swiftfox)/i, // Swiftfox
		/(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
		// IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
		/(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
		// Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
		/(firefox)\/([\w\.]+)/i, // Other Firefox-based
		/(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, // Mozilla

		// Other
		/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
		// Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
		/(links) \(([\w\.]+)/i, // Links
		/panasonic;(viera)/i, // Panasonic Viera
	],
	[NAME, VERSION],
	[
		/(cobalt)\/([\w\.]+)/i, // Cobalt
	],
	[NAME, [VERSION, /[^\d\.]+./, EMPTY]],
];

const REGEX_DEVICE = [
	//////////////////////////
	// MOBILES & TABLETS
	/////////////////////////
	// Samsung
	[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i],
	[MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]],
	[/\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i, /samsung[- ]([-\w]+)/i, /sec-(sgh\w+)/i],
	[MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]],
	// Apple
	[
		/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i, // iPod/iPhone
	],
	[MODEL, [VENDOR, APPLE], [TYPE, MOBILE]],
	[
		/\((ipad);[-\w\),; ]+apple/i, // iPad
		/applecoremedia\/[\w\.]+ \((ipad)/i,
		/\b(ipad)\d\d?,\d\d?[;\]].+ios/i,
	],
	[MODEL, [VENDOR, APPLE], [TYPE, TABLET]],
	[/(macintosh);/i],
	[MODEL, [VENDOR, APPLE]],
	// Huawei
	[/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i],
	[MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]],
	[/(?:huawei|honor)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i],
	[MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]],
	// Xiaomi
	[
		/\b(poco[\w ]+)(?: bui|\))/i, // Xiaomi POCO
		/\b; (\w+) build\/hm\1/i, // Xiaomi Hongmi 'numeric' models
		/\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, // Xiaomi Hongmi
		/\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, // Xiaomi Redmi
		/\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i, // Xiaomi Mi
	],
	[
		[MODEL, /_/g, ' '],
		[VENDOR, XIAOMI],
		[TYPE, MOBILE],
	],
	[
		/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i, // Mi Pad tablets
	],
	[
		[MODEL, /_/g, ' '],
		[VENDOR, XIAOMI],
		[TYPE, TABLET],
	],
	// OPPO
	[/; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i],
	[MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]],
	// Vivo
	[/vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i],
	[MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]],
	// Realme
	[/\b(rmx[12]\d{3})(?: bui|;|\))/i],
	[MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]],
	// Motorola
	[
		/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
		/\bmot(?:orola)?[- ](\w*)/i,
		/((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i,
	],
	[MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]],
	[/\b(mz60\d|xoom[2 ]{0,2}) build\//i],
	[MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]],
	// LG
	[/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i],
	[MODEL, [VENDOR, LG], [TYPE, TABLET]],
	[
		/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
		/\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
		/\blg-?([\d\w]+) bui/i,
	],
	[MODEL, [VENDOR, LG], [TYPE, MOBILE]],
	// Sharp
	[/\b(sh-?[altvz]?\d\d[a-ekm]?)/i],
	[MODEL, [VENDOR, SHARP], [TYPE, MOBILE]],
	// Lenovo
	[/(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i],
	[MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]],
	// Nokia
	[/(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i],
	[
		[MODEL, /_/g, ' '],
		[VENDOR, 'Nokia'],
		[TYPE, MOBILE],
	],
	// Google
	[
		/(pixel c)\b/i, // Google Pixel C
	],
	[MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]],
	[
		/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i, // Google Pixel
	],
	[MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]],
	// Sony
	[/droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i],
	[MODEL, [VENDOR, SONY], [TYPE, MOBILE]],
	[/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i],
	[
		[MODEL, 'Xperia Tablet'],
		[VENDOR, SONY],
		[TYPE, TABLET],
	],
	// OnePlus
	[/ (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i],
	[MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]],
	// Amazon
	[
		/(alexa)webm/i,
		/(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i, // Kindle Fire without Silk / Echo Show
		/(kf[a-z]+)( bui|\)).+silk\//i, // Kindle Fire HD
	],
	[MODEL, [VENDOR, AMAZON], [TYPE, TABLET]],
	[
		/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i, // Fire Phone
	],
	[
		[MODEL, /(.+)/g, 'Fire Phone $1'],
		[VENDOR, AMAZON],
		[TYPE, MOBILE],
	],
	// BlackBerry
	[
		/(playbook);[-\w\),; ]+(rim)/i, // BlackBerry PlayBook
	],
	[MODEL, VENDOR, [TYPE, TABLET]],
	[
		/\b((?:bb[a-f]|st[hv])100-\d)/i,
		/\(bb10; (\w+)/i, // BlackBerry 10
	],
	[MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]],
	// Asus
	[/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i],
	[MODEL, [VENDOR, ASUS], [TYPE, TABLET]],
	[/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],
	[MODEL, [VENDOR, ASUS], [TYPE, MOBILE]],
	// HTC
	[
		/(nexus 9)/i, // HTC Nexus 9
	],
	[MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]],
	[
		/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, // HTC
		// ZTE
		/(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
		/(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i, // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
	],
	[VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]],
	// Acer
	[/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i],
	[MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]],
	// Meizu
	[/droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i],
	[MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]],
	// MIXED
	[
		/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
		// BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
		/(hp) ([\w ]+\w)/i, // HP iPAQ
		/(asus)-?(\w+)/i, // Asus
		/(microsoft); (lumia[\w ]+)/i, // Microsoft Lumia
		/(lenovo)[-_ ]?([-\w]+)/i, // Lenovo
		/(jolla)/i, // Jolla
		/(oppo) ?([\w ]+) bui/i, // OPPO
	],
	[VENDOR, MODEL, [TYPE, MOBILE]],
	[
		/(kobo)\s(ereader|touch)/i, // Kobo
		/(archos) (gamepad2?)/i, // Archos
		/(hp).+(touchpad(?!.+tablet)|tablet)/i, // HP TouchPad
		/(kindle)\/([\w\.]+)/i, // Kindle
	],
	[VENDOR, MODEL, [TYPE, TABLET]],
	[
		/(surface duo)/i, // Surface Duo
	],
	[MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]],
	[
		/droid [\d\.]+; (fp\du?)(?: b|\))/i, // Fairphone
	],
	[MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]],
	[
		/(shield[\w ]+) b/i, // Nvidia Shield Tablets
	],
	[MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]],
	[
		/(sprint) (\w+)/i, // Sprint Phones
	],
	[VENDOR, MODEL, [TYPE, MOBILE]],
	[
		/(kin\.[onetw]{3})/i, // Microsoft Kin
	],
	[
		[MODEL, /\./g, ' '],
		[VENDOR, MICROSOFT],
		[TYPE, MOBILE],
	],
	[
		/droid.+; ([c6]+|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i, // Zebra
	],
	[MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]],
	[/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],
	[MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]],
	///////////////////
	// CONSOLES
	///////////////////
	[
		/(ouya)/i, // Ouya
		/(nintendo) (\w+)/i, // Nintendo
	],
	[VENDOR, MODEL, [TYPE, CONSOLE]],
	[
		/droid.+; (shield) bui/i, // Nvidia
	],
	[MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]],
	[
		/(playstation \w+)/i, // Playstation
	],
	[MODEL, [VENDOR, SONY], [TYPE, CONSOLE]],
	[
		/\b(xbox(?: one)?(?!; xbox))[\); ]/i, // Microsoft Xbox
	],
	[MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]],
	///////////////////
	// WEARABLES
	///////////////////
	[
		/((pebble))app/i, // Pebble
	],
	[VENDOR, MODEL, [TYPE, WEARABLE]],
	[
		/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i, // Apple Watch
	],
	[MODEL, [VENDOR, APPLE], [TYPE, WEARABLE]],
	[
		/droid.+; (glass) \d/i, // Google Glass
	],
	[MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]],
	[/droid.+; (wt63?0{2,3})\)/i],
	[MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]],
	[
		/(quest( 2| pro)?)/i, // Oculus Quest
	],
	[MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]],
	///////////////////
	// SMARTTVS
	///////////////////
	[
		/smart-tv.+(samsung)/i, // Samsung
	],
	[VENDOR, [TYPE, SMARTTV]],
	[/hbbtv.+maple;(\d+)/i],
	[
		[MODEL, /^/, 'SmartTV'],
		[VENDOR, SAMSUNG],
		[TYPE, SMARTTV],
	],
	[
		/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i, // LG SmartTV
	],
	[
		[VENDOR, LG],
		[TYPE, SMARTTV],
	],
	[
		/(apple) ?tv/i, // Apple TV
	],
	[VENDOR, [MODEL, APPLE + ' TV'], [TYPE, SMARTTV]],
	[
		/crkey/i, // Google Chromecast
	],
	[
		[MODEL, CHROME + 'cast'],
		[VENDOR, GOOGLE],
		[TYPE, SMARTTV],
	],
	[
		/droid.+aft(\w)( bui|\))/i, // Fire TV
	],
	[MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]],
	[
		/\(dtv[\);].+(aquos)/i,
		/(aquos-tv[\w ]+)\)/i, // Sharp
	],
	[MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]],
	[
		/(bravia[\w ]+)( bui|\))/i, // Sony
	],
	[MODEL, [VENDOR, SONY], [TYPE, SMARTTV]],
	[
		/(mitv-\w{5}) bui/i, // Xiaomi
	],
	[MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]],
	[
		/Hbbtv.*(technisat) (.*);/i, // TechniSAT
	],
	[VENDOR, MODEL, [TYPE, SMARTTV]],
	[
		/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, // Roku
		/hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i, // HbbTV devices
	],
	[
		[VENDOR, trim],
		[MODEL, trim],
		[TYPE, SMARTTV],
	],
	[
		/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i, // SmartTV from Unidentified Vendors
	],
	[[TYPE, SMARTTV]],
	///////////////////
	// EMBEDDED
	///////////////////
	[
		/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i, // Tesla
	],
	[VENDOR, [TYPE, EMBEDDED]],
	[
		/(aeobc)\b/i, // Echo Dot
	],
	[MODEL, [VENDOR, AMAZON], [TYPE, EMBEDDED]],
	////////////////////
	// MIXED (GENERIC)
	///////////////////
	[
		/droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i, // Android Phones from Unidentified Vendors
	],
	[MODEL, [TYPE, MOBILE]],
	[
		/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i, // Android Tablets from Unidentified Vendors
	],
	[MODEL, [TYPE, TABLET]],
	[
		/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i, // Unidentifiable Tablet
	],
	[[TYPE, TABLET]],
	[
		/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i, // Unidentifiable Mobile
	],
	[[TYPE, MOBILE]],
	[
		/(android[-\w\. ]{0,9});.+buil/i, // Generic Android Device
	],
	[MODEL, [VENDOR, 'Generic']],
];

const regexParser = function (ua, patterns) {
	if (!ua || !patterns) {
		return null;
	}
	let res = null;
	let i = 0;
	let matches = null;

	while (i < patterns.length && !matches) {
		const regex = patterns[i]; // even sequence
		const props = patterns[i + 1]; // odd sequence
		let j = 0;

		// try to match uastring with regexes
		while (j < regex.length && !matches) {
			if (!regex[j]) {
				break;
			}
			matches = regex[j++].exec(ua);
			if (matches) {
				// 匹配到了
				res = {};
				let matchIdx = 0;
				for (let k = 0; k < props.length; k++) {
					const prop = props[k];
					const match = matches[++matchIdx];
					if (typeof prop === 'object' && prop.length > 0) {
						if (prop.length === 2) {
							if (typeof prop[1] === 'function') {
								res[prop[0]] = prop[1](matches[k + 1]);
							} else {
								res[prop[0]] = prop[1];
							}
						} else if (prop.length === 3) {
							if (typeof prop[1] === 'function' && !(prop[1].exec && prop[1].test)) {
								// call function (usually string mapper)
								res[prop[0]] = match ? prop[1](match, prop[2]) : undefined;
							} else {
								// sanitize match using given function
								res[prop[0]] = match ? match.replace(prop[1], prop[2]) : undefined;
							}
						} else if (prop.length === 4) {
							res[prop[0]] = match ? prop[3](match.replace(prop[1], prop[2])) : undefined;
						}
					} else {
						res[prop] = match ? match : undefined;
					}
				}
				break;
			}
		}

		i += 2;

		if (matches) {
			break;
		}
	}

	return res;
};

const browserInfo = regexParser(USER_AGENT, REGEX_BROWSER);
const deviceInfo = regexParser(USER_AGENT, REGEX_DEVICE);
const osInfo = regexParser(USER_AGENT, REGEX_OS);

const detect = {
	browser: {},
	os: {},
	device: {},
};

if (browserInfo) {
	detect.browser.info = browserInfo;
	if (browserInfo[NAME]) {
		detect.browser[browserInfo[NAME].toLowerCase()] = true;
	}
	detect.browser.version = browserInfo[VERSION];
}

if (deviceInfo) {
	detect.device.info = deviceInfo;
	if (deviceInfo[TYPE]) {
		detect.device[deviceInfo[TYPE].toLowerCase()] = true;
	}
	detect.device[VENDOR] = deviceInfo[VENDOR];
}

if (osInfo) {
	detect.os.info = osInfo;
	if (osInfo[NAME]) {
		detect.os[osInfo[NAME].toLowerCase()] = true;
	}
	detect.os.version = osInfo[VERSION] || null;
	detect.os.tablet = deviceInfo ? deviceInfo[TYPE] === TABLET : false;
	detect.os.phone = deviceInfo ? deviceInfo[TYPE] === MOBILE : false;
}

export default detect;
